module.exports = __webpack_public_path__ + "img/eduzz-white.5de7762d.svg";